const runtimeConfig = window.APP_CONFIG || {};

export default {
  VUE_APP_API_SOCKET: runtimeConfig.VUE_APP_API_SOCKET || process.env.VUE_APP_API_SOCKET,
  UMAMI_SRC: runtimeConfig.UMAMI_SRC || process.env.VUE_APP_UMAMI_SRC,
  UMAMI_ID: runtimeConfig.UMAMI_ID || process.env.VUE_APP_UMAMI_ID
};
